import { createTheme, adaptV4Theme } from "@mui/material/styles";

// NOTE (v5 migration): adaptV4Theme copies `overrides` verbatim into
// styleOverrides, but emotion does NOT resolve JSS `$rule` references —
// selectors must use the v5 global class names (.Mui-focused,
// .MuiOutlinedInput-notchedOutline, …) or they are silently dropped.
const GlobalTheme = createTheme(
  adaptV4Theme({
    // Brand palette: v5 components resolve color="primary"/"secondary" from
    // the theme (v4 checkboxes etc. were overridden per-component instead).
    palette: {
      primary: { main: "#9B51E0" },
      secondary: { main: "#9B51E0" },
      error: { main: "#E52727" },
      success: { main: "#219653" },
      warning: { main: "#F2994A" },
      info: { main: "#1366D6" },
    },
    // v4 default-prop compatibility: v5 changed these defaults, which would
    // silently restyle any component that relies on them.
    // Deliberately NO MuiSelect entry: a theme-level Select variant would
    // defeat variant inheritance from <FormControl variant="outlined">
    // wrappers (Select only inherits when its own variant is undefined);
    // bare Selects inherit "standard" from the MuiFormControl default.
    props: {
      MuiTextField: { variant: "standard" },
      MuiFormControl: { variant: "standard" },
      MuiButton: { color: "inherit" },
      MuiTabs: { textColor: "inherit", indicatorColor: "secondary" },
      MuiLink: { underline: "hover" },
    },
    overrides: {
      MuiOutlinedInput: {
        root: {
          color: "#172B4D !important",
          height: "40px !important",
          // Multiline fields must grow with their content; the fixed 40px above
          // is only correct for single-line inputs and otherwise clips/overflows.
          "&.MuiInputBase-multiline": {
            height: "auto !important",
          },
          "& .MuiOutlinedInput-notchedOutline, &:hover .MuiOutlinedInput-notchedOutline":
            {
              border: "1px solid #5E6C84",
              borderRadius: "8px",
            },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#9b51e0",
          },
          "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
            borderColor: "#5e6c84",
            border: "1px solid #5E6C84",
          },
          "& ::placeholder ": {
            fontFamily: "PoppinsRegular,  sans-serif",
            fontSize: "0.875rem",
            lineHeight: " 20px",
            display: "flex",
            alignItems: "center",
            letterSpacing: "-0.2px",

            color: "#5e6c84 !important",
          },
          "&.MuiInputBase-adornedEnd": {
            padding: 0,
          },
        },
        notchedOutline: {},
      },
      MuiFormHelperText: {
        root: {
          fontFamily: "PoppinsRegular,  sans-serif",
          fontSize: "0.75rem !important",
          lineHeight: "16px",
          letterSpacing: "-0.2px",
          color: "#5E6C84",
          margin: "0px !important",
          "&.Mui-error": {
            color: "#E52727",
          },
        },
      },
      MuiIconButton: {
        root: {
          padding: "2px",
        },
      },
      MuiCheckbox: {
        // v4's default checkbox color was "secondary"; v5's is "primary" —
        // override the root so the purple outline applies either way.
        root: {
          color: "#9b51e0",
          "&.Mui-checked": {
            color: "#9b51e0",
          },
        },
      },
      MuiBoxBoot: {
        padding: "2px",
      },
      // 2026-07 polish: consistent dialog surface — softer layered shadow,
      // slightly rounder corners. Applies to every Dialog app-wide.
      MuiDialog: {
        paper: {
          borderRadius: "12px",
          boxShadow:
            "0 10px 15px rgba(0, 0, 0, 0.10), 0 4px 6px rgba(0, 0, 0, 0.05)",
        },
      },
      MuiTooltip: {
        tooltip: {
          fontFamily: "PoppinsRegular, sans-serif",
          fontSize: "0.75rem",
        },
      },
    },
  })
);

export default GlobalTheme;
